/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.TRIGGER.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {FetchRequest, TriggerInput, Trigger, UUID} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * trigger on the server. Only name, description and trigger type need to be specified for this purpose.
 * @param triggerInput An object of type TriggerInput containing the input data for creating the trigger.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_trigger(triggerInput: TriggerInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER,
        method: HttpMethods.POST,
        query_parameters: {},
        body: triggerInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * trigger on the server.
 * @param trigger An object of type Trigger containing the updated trigger data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_trigger(trigger: Trigger): FetchRequest {
    const triggerPayload = Object.fromEntries(
        Object.entries(trigger).filter(([key]) => key !== "trigger_rows")
    );
    return {
        api_endpoint: ApiEndPoints.TRIGGER,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: triggerPayload,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of triggers
 * on the server.
 * @param transaction_id .The UUID of the transaction to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_triggers(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER,
        method: HttpMethods.GET,
        query_parameters: { transaction_id:transaction_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * trigger on the server.
 * @param trigger_id The UUID of the trigger to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_trigger(trigger_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRIGGER,
        method: HttpMethods.DELETE,
        query_parameters: { trigger_id: trigger_id },
    };
}
